import { addDaysToKey, toManilaParts } from "../../utils/manilaTime";

// All overtime queries share this prefix so one invalidation refreshes them.
export const OVERTIME_KEY = "me:overtime";

export const OVERTIME_STATUS = {
  PENDING: { label: "Waiting for approval", tone: "amber" },
  APPROVED: { label: "Approved", tone: "green" },
  REJECTED: { label: "Rejected", tone: "red" },
  CANCELLED: { label: "Cancelled", tone: "gray" },
};

export const STATUS_TABS = [
  { id: "", label: "All" },
  { id: "PENDING", label: "Pending" },
  { id: "APPROVED", label: "Approved" },
  { id: "REJECTED", label: "Rejected" },
  { id: "CANCELLED", label: "Cancelled" },
];

export const OVERTIME_RULE_TEXT =
  "File overtime before you work it: only approved time you actually work counts. Under 30 min is not overtime; 30–59 min counts as 30; from 1 hour every minute counts. You can file up to 31 days ahead.";

export const LATE_FILING_TEXT =
  "Overtime must be filed before it starts. If you couldn't file it in time, ask HR to file it for you.";

export const MAX_DAYS_AHEAD = 31;

// Every day shape (summary, DTR, today) has overtimeApproved: true once an
// overtime request for that day is approved.
export const hasApprovedOvertime = (day) => !!day?.overtimeApproved;

// Same rule as the server (overtime.rules.ts), for the live "counts as" hint.
export const countedOvertimeMinutes = (minutes) => {
  const m = Math.max(Math.floor(minutes), 0);
  if (m < 30) return 0;
  if (m < 60) return 30;
  return m;
};

// 150 -> "2 h 30 m", 45 -> "45 m"
export const formatMinutes = (minutes) => {
  if (minutes == null) return "—";
  const m = Math.round(Number(minutes));
  const h = Math.floor(m / 60);
  const rest = m % 60;
  if (!h) return `${rest} m`;
  return rest ? `${h} h ${rest} m` : `${h} h`;
};

// Minutes between two "HH:mm" on the same date; an end at or before the
// start means the next day (overtime past midnight).
export const minutesBetweenTimes = (start, end) => {
  if (!start || !end) return 0;
  const toMin = (t) => Number(t.slice(0, 2)) * 60 + Number(t.slice(3, 5));
  const diff = toMin(end) - toMin(start);
  return diff > 0 ? diff : diff + 24 * 60;
};

// Planned overtime suggestion ("HH:mm"): from when today's regular 8 hours end
// (first check-in + 8 h), for an hour. Other days: nothing to suggest.
export const suggestPlannedTimes = (preview, dateKey) => {
  const ends = preview?.regularEndsAt && toManilaParts(preview.regularEndsAt);
  if (!ends || ends.dateKey !== dateKey) return { start: "", end: "" };
  const plusHour = toManilaParts(
    new Date(
      new Date(preview.regularEndsAt).getTime() + 60 * 60_000,
    ).toISOString(),
  );
  return { start: ends.time, end: plusHour.time };
};

// True when the start ("HH:mm" on dateKey, Manila) is already in the past.
export const startHasPassed = (
  dateKey,
  start,
  now = toManilaParts(new Date().toISOString()),
) => {
  if (!dateKey || !start) return false;
  if (dateKey !== now.dateKey) return dateKey < now.dateKey;
  return start < now.time;
};

export const endsNextDay = (start, end) => !!start && !!end && end <= start;

export const latestFileableDate = (todayKey) =>
  addDaysToKey(todayKey, MAX_DAYS_AHEAD);
